// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SeriesTopTen_container__fuF7j {
  margin: 0 auto;
  padding: 0px;
  color: white;
  max-width: 95%;
}

.SeriesTopTen_title__GeWXE {
  font-size: 20px;
  margin-bottom: 5px;
  font-weight: bold;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5px;
}

.SeriesTopTen_swiperContainer__vMsAK {
  width: 100%;
}

.SeriesTopTen_seriesSlide__DS9EA {
  display: flex;
  justify-content: center;
  align-items: center;
}

.SeriesTopTen_seriesItem__iW7Me {
  position: relative;
  width: 100%;
  max-width: 250px;
  aspect-ratio: auto;
  transition: transform 0.3s ease;
}

.SeriesTopTen_seriesItem__iW7Me:hover {
  transform: scale(1.01);
  z-index: 10;
}

.SeriesTopTen_rankContainer__\\+3SFN {
  position: absolute;
  left: -40px;
  z-index: 3;
  bottom: -40px;
}

.SeriesTopTen_rank__Xh5RF {
  font-size: 11rem;
  font-weight: bold;
  color: white;
  cursor: pointer;
}

.SeriesTopTen_imageContainer__jUX1B {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 2;
  cursor: pointer;
}

.SeriesTopTen_seriesImage__oZaY7 {
  width: 100%;
  height: 86%;
  object-fit: cover;
  border-radius: 10px;
}

.SeriesTopTen_loading__RpU5G {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.SeriesTopTen_error__nEW0H {
  color: #e50914;
  text-align: center;
  padding: 20px;
}

.SeriesTopTen_noContent__T7I1l {
  text-align: center;
  padding: 20px;
  font-size: 1.2rem;
}

.SeriesTopTen_content__TYfOD {
  width: 100%;
}

/* Swiper custom styles */
.SeriesTopTen_swiperContainer__vMsAK .swiper-button-next,
.SeriesTopTen_swiperContainer__vMsAK .swiper-button-prev {
  color: #e50914 !important;
}

.SeriesTopTen_swiperContainer__vMsAK .swiper-pagination-bullet-active {
  background-color: #e50914 !important;
}

@media (min-width: 768px) and (max-width:1400px) {
 .SeriesTopTen_swiperContainer__vMsAK{
  padding-left: 20px;
  padding-right: 20px;
 }
}
/* Mobile optimizations */
@media (max-width: 768px) {
  .SeriesTopTen_container__fuF7j {
    padding: 0px;
    max-width: 95%;
    margin: 0 auto;
  }
  
  .SeriesTopTen_rankContainer__\\+3SFN {
    left: -12px;
    bottom: -30px;
  }
  
  .SeriesTopTen_swiperContainer__vMsAK {
    padding-left: 5px;
    padding-right: 5px;
  }
  .SeriesTopTen_rank__Xh5RF{
    font-size: 10rem;
  }
}
@media (max-width: 480px) {
  .SeriesTopTen_rank__Xh5RF {
    font-size: 9rem;
  }
  .SeriesTopTen_title__GeWXE {
    font-size: 18px;
  }
  .SeriesTopTen_container__fuF7j{
    width: 100%;
  }
 
}`, "",{"version":3,"sources":["webpack://./src/Homepage/components/Css/SeriesTopTen.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;AACD;AACA,yBAAyB;AACzB;EACE;IACE,YAAY;IACZ,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;;AAEF","sourcesContent":[".container {\n  margin: 0 auto;\n  padding: 0px;\n  color: white;\n  max-width: 95%;\n}\n\n.title {\n  font-size: 20px;\n  margin-bottom: 5px;\n  font-weight: bold;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 5px;\n}\n\n.swiperContainer {\n  width: 100%;\n}\n\n.seriesSlide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.seriesItem {\n  position: relative;\n  width: 100%;\n  max-width: 250px;\n  aspect-ratio: auto;\n  transition: transform 0.3s ease;\n}\n\n.seriesItem:hover {\n  transform: scale(1.01);\n  z-index: 10;\n}\n\n.rankContainer {\n  position: absolute;\n  left: -40px;\n  z-index: 3;\n  bottom: -40px;\n}\n\n.rank {\n  font-size: 11rem;\n  font-weight: bold;\n  color: white;\n  cursor: pointer;\n}\n\n.imageContainer {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.seriesImage {\n  width: 100%;\n  height: 86%;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n.error {\n  color: #e50914;\n  text-align: center;\n  padding: 20px;\n}\n\n.noContent {\n  text-align: center;\n  padding: 20px;\n  font-size: 1.2rem;\n}\n\n.content {\n  width: 100%;\n}\n\n/* Swiper custom styles */\n.swiperContainer :global(.swiper-button-next),\n.swiperContainer :global(.swiper-button-prev) {\n  color: #e50914 !important;\n}\n\n.swiperContainer :global(.swiper-pagination-bullet-active) {\n  background-color: #e50914 !important;\n}\n\n@media (min-width: 768px) and (max-width:1400px) {\n .swiperContainer{\n  padding-left: 20px;\n  padding-right: 20px;\n }\n}\n/* Mobile optimizations */\n@media (max-width: 768px) {\n  .container {\n    padding: 0px;\n    max-width: 95%;\n    margin: 0 auto;\n  }\n  \n  .rankContainer {\n    left: -12px;\n    bottom: -30px;\n  }\n  \n  .swiperContainer {\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n  .rank{\n    font-size: 10rem;\n  }\n}\n@media (max-width: 480px) {\n  .rank {\n    font-size: 9rem;\n  }\n  .title {\n    font-size: 18px;\n  }\n  .container{\n    width: 100%;\n  }\n \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SeriesTopTen_container__fuF7j`,
	"title": `SeriesTopTen_title__GeWXE`,
	"swiperContainer": `SeriesTopTen_swiperContainer__vMsAK`,
	"seriesSlide": `SeriesTopTen_seriesSlide__DS9EA`,
	"seriesItem": `SeriesTopTen_seriesItem__iW7Me`,
	"rankContainer": `SeriesTopTen_rankContainer__+3SFN`,
	"rank": `SeriesTopTen_rank__Xh5RF`,
	"imageContainer": `SeriesTopTen_imageContainer__jUX1B`,
	"seriesImage": `SeriesTopTen_seriesImage__oZaY7`,
	"loading": `SeriesTopTen_loading__RpU5G`,
	"error": `SeriesTopTen_error__nEW0H`,
	"noContent": `SeriesTopTen_noContent__T7I1l`,
	"content": `SeriesTopTen_content__TYfOD`
};
export default ___CSS_LOADER_EXPORT___;
